import { Inbox } from "lucide-react";

/**
 * BW19 PR-D — empty state for the inbox.
 *
 * Adherence-neutral copy following State / Meaning / Next move. Avoids
 * gamified streak language and unsolicited praise per BW18 PR-D rules.
 */

export function InboxEmptyState() {
  return (
    <section
      aria-label="Inbox empty"
      style={{
        padding: "var(--space-8)",
        textAlign: "center",
        background: "var(--bg-2)",
        border: "1px solid var(--hair)",
        borderRadius: "var(--radius-card)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "var(--space-3)",
      }}
    >
      <Inbox size={32} color="var(--fg-2)" aria-hidden />
      <p style={{ margin: 0, color: "var(--fg)", fontSize: 14 }}>
        State: no captures awaiting review.
      </p>
      <p style={{ margin: 0, color: "var(--fg-2)", fontSize: 13 }}>
        Meaning: triage is current.
      </p>
      <p style={{ margin: 0, color: "var(--fg-2)", fontSize: 13 }}>
        Next move: press n to capture anything on your mind.
      </p>
    </section>
  );
}
